import * as Loadable from 'react-loadable'

import ModalLoading from '../modalLoading'

export default (Loadable as any)({
  loader: () =>
    import(/* webpackChunkName: "signUpModal" */ './signUpContainer'),
  loading: ModalLoading,
  webpack: () => [require.resolveWeak('./signUpContainer')],
  modules: ['./signUpContainer']
})
